import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=0c0df9b6&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=0c0df9b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0df9b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VToolbarSideIcon } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VLayout,
  VNavigationDrawer,
  VToolbarSideIcon,
})
